import { useContext } from 'react';
import { useIntl } from 'react-intl';
import {
  SnackbarContext,
  SnackbarVariant,
  useEventCallback,
} from '@eas/common-web';

export function useDownloadAttachmentsZip({ url }: { url?: string }) {
  const { showSnackbar } = useContext(SnackbarContext);
  const intl = useIntl();

  const callApi = useEventCallback(async () => {
    if (!url) {
      return;
    }

    showSnackbar(
      intl.formatMessage({
        id: 'ES__ATTACHMENTS_ZIP__REQUEST_SENT',
        defaultMessage: 'ZIP archiv se generuje, čekejte prosím.',
      }),
      SnackbarVariant.SUCCESS
    );

    const a = document.createElement('a');
    a.href = url;
    a.download = '';

    document.body.appendChild(a);
    a.click();
    a.remove();
  });

  return { callApi };
}
